<template>
  <form @submit.prevent="createTaxData" class="form">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">{{ $t('button.add') }}</h5>

        <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">

          <span class="svg-icon svg-icon-1">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
              <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                fill="currentColor" />
              <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                fill="currentColor" />
            </svg>
          </span>

        </div>


      </div>
      <div class="modal-body">
        <div class="d-flex flex-column mb-8 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold mb-2">
            <span class="required">{{ $t('taxe.title') }}</span>
          </label>
          <input type="text" class="form-control form-control-solid" v-model="formData.title" required
            :placeholder="$t('taxe.title_placeholder')" />
        </div>
        <div class="d-flex flex-column mb-8 fv-row">
          <label class="d-flex align-items-center fs-6 fw-bold mb-2">
            <span class="required">{{ $t('taxe.type') }}</span>
          </label>
          <select name="tax_type" class="form-select form-select-solid kt_select2"
            v-model="formData.type" required :data-placeholder="$t('taxe.type_placeholder')"
            data-dropdown-parent="#createModal" data-search="true">
            <option value="amount">{{ $t('taxe.type_amount') }}</option>
            <option value="percent">{{ $t('taxe.type_percent') }}</option>
          </select>
        </div>
        <div class="d-flex flex-column mb-8 fv-row" v-if="formData.type === 'amount'">
          <label class="d-flex align-items-center fs-6 fw-bold mb-2">
            <span class="required">{{ $t('taxe.amount') }} {{ currency ? ('(' + currency + ')') : '' }}</span>
          </label>
          <input type="number" @keypress="onlyNumber" step=".01" class="form-control form-control-solid"
            v-model="formData.amount" required :placeholder="$t('taxe.amount_placeholder')" />
        </div>
        <div class="d-flex flex-column mb-8 fv-row" v-if="formData.type === 'percent'">
          <label class="d-flex align-items-center fs-6 fw-bold mb-2">
            <span class="required">{{ $t('taxe.percent') }}</span>
          </label>

          <div class="input-group mb-5">
            <input type="number" @keypress="onlyNumber" step=".01" class="form-control form-control-solid"
              v-model="formData.amount" required :placeholder="$t('taxe.percent_placeholder')" />
            <span class="input-group-text" id="basic-addon2">%</span>
          </div>
        </div>


      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-sm btn-light" data-bs-dismiss="modal">{{ $t('button.close') }}</button>
        <button type="submit" class="btn btn-sm btn-primary fw-bolder" :disabled="processCreating"
          style="margin-right: 10px;">
          <span class="indicator-label">{{ $t('button.save') }}</span>
          <span class="indicator-progress" v-show="processCreating">{{ $t('loading') }}
            <span class="spinner-border spinner-border-sm align-middle ms-2"></span>
          </span>
        </button>
      </div>
    </div>
  </form>
</template>

<script setup>

import { computed, ref } from "vue";
import { useStore } from "vuex";

const store = useStore()
const props = defineProps({
  tax: { type: Object, default: {
    title: '',
    type: 'percent',
    amount: 0,
  } }
})
const emits = defineEmits(['afterCreated'])

const formData = ref(props.tax)
const processCreating = ref(false)

const currency = computed(() => 'XOF')

async function loadTaxes() {
  await store.dispatch('taxes/loadTaxes')
}
function createTaxData() {
  processCreating.value = true
  store.dispatch('taxes/createTaxe', formData.value)
    .then((response) => {
      loadTaxes()
      processCreating.value = false
      emits('afterCreated', response.data.taxe)
      formData.value = {
        title: '',
        type: 'percent',
        amount: 0,
      }
      window.toastr['success'](i18n.global.t('notification.taxe_created'))
    })
    .catch(err => {
      processCreating.value = false
    })
}

function onlyNumber($event) {
  let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
  if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
    $event.preventDefault();
  }
}

</script>

<style scoped></style>